export default "__VITE_ASSET__85578cb9__"